import {
    ColoursObj,
    Icon,
    TEventrIcons,
    Typography,
} from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { useSignal } from '@preact/signals-react'
import { useEffect, useRef } from 'react'
import { IEditComponent } from '../../../data/Data'
import { editHeaderTranslation } from '../../../i18n/translateHelpers'
import { ComponentFinderEdit } from '../componentFinderEdit'
interface ISectionEditProps {
    options: IEditComponent
    _id?: string
}

export const SectionEdit = ({ options, _id }: ISectionEditProps) => {
    const componentsRef = useRef(null)
    const componentsRendered = useSignal(false)

    useEffect(() => {
        const updateComponentsRendered = () => {
            if (componentsRef.current) {
                const height = componentsRef.current.offsetHeight
                componentsRendered.value = height !== 0
            }
        }

        updateComponentsRendered() // Initial check

        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                updateComponentsRendered()
            })
        })

        if (componentsRef.current) {
            resizeObserver.observe(componentsRef.current)
        }

        return () => {
            resizeObserver.disconnect()
        }
    }, [options.components])

    return (
        <Stack>
            {componentsRendered.value && (
                <Box
                    borderRadius={'8px'}
                    height={'56px'}
                    marginBottom={'8px'}
                    bgcolor={ColoursObj.backgrounds.secondary}
                >
                    <Stack padding={'16px'} direction={'row'} spacing={'8px'}>
                        <Icon
                            name={options.headerIcon as TEventrIcons}
                            iconColour={ColoursObj.core.secondary}
                        />
                        <Typography
                            variant="bodyBold"
                            id={options?.headerText?.toLowerCase()}
                            color={ColoursObj.font.primary}
                        >
                            {editHeaderTranslation(options?.headerText ?? '') ??
                                'Booking Details'}
                        </Typography>
                    </Stack>
                </Box>
            )}
            <Stack ref={componentsRef} spacing={'16px'}>
                {options.components?.map(
                    (option: IEditComponent, index: number) => {
                        return (
                            _id && (
                                <ComponentFinderEdit
                                    key={index}
                                    _id={_id}
                                    editComponent={option}
                                />
                            )
                        )
                    }
                )}
            </Stack>
        </Stack>
    )
}
